
import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from "react-router-dom"
import Button from '../formfields/Button'
import JsonDebug from '../ui-elements/JsonDebug'
import Modal from '../ui-elements/Modal'
import SelectRecursiveFolder from './SelectRecursiveFolder'
import RedAlert from '../ui-elements/RedAlert'
import { subscribe } from '../utils/pubsub'
import { removeNonAlphanumeric } from '../utils/removeNonAlphanumeric'

type Props = {
    folders: ObjectStringKeyAnyValue
    setShowAddNewFolder: React.Dispatch<React.SetStateAction<any>>

}


function AddNewFolder({
    folders,
    setShowAddNewFolder
}: Props) {

    const {
        tableData,
        setShowModal,
        sendMessageToWebsocket
    } = useContext(GlobalContext)

    const [selectedFolderId, setSelectedFolderId] = useState<string | null>(null)
    const [folderName, setFolderName] = useState<string | null>(null)
    const [errorMessage, setErrorMessage] = useState<string | null>(null)
    const allFolderNames = Object.keys(folders).map((key) => folders[key].DisplayName)

    const addFolder = () => {
        if (!folderName) {
            setErrorMessage('Please enter a folder name')
            return
        }
        else if (allFolderNames.includes(folderName)) {
            setErrorMessage('Folder name already exists')
            return
        } else {
            setErrorMessage(null)
            setShowAddNewFolder(false)
            setShowModal({ "spinner": "Adding folder..." })
            const item_id = `fldr-${removeNonAlphanumeric(folderName).substring(0, 8)}-${Date.now()}`
            const payload = JSON.stringify({
                action: "portal",
                subAction: "addFolder",
                folderId: item_id,
                parentFolderId: selectedFolderId,
                folderName: folderName
            })
            const unsubscribe = subscribe("folderAdded", data => {
              if (data.Id === item_id) {
                setShowModal(null)
              }
              unsubscribe()
            })
            sendMessageToWebsocket(payload)
        }

    }


    return <Modal>
        <div className={`w-full flex flex-col gap-4 items-center justify-center`}>



            <h3 className={`text-3xl font-brandblue font-righteous`}>Add a new folder</h3>

            {/* new parentid: [{selectedFolderId}] */}

            <p className={`font-bold`}>New folder name:</p>
            <input
                className={`bg-white drop-shadow-lg border border-gray-300 text-gray-900 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 block w-full text-sm px-3 py-2`}
                type={`text`}
                onChange={(e) => setFolderName(e.target.value)}
                value={folderName || ''}
            />

            <p className={`font-bold`}>Select folder to move to:</p>
            <SelectRecursiveFolder
                folders={folders}
                setSelectedFolderId={setSelectedFolderId}
                selectedFolderId={selectedFolderId}
                showTopLevel={true}
                
            />

            <div className={`w-full flex flex-row gap-1`}>
                <Button
                    onClick={() => setShowAddNewFolder(null)}
                    text='Cancel'
                    variant='gray'
                    size='big'
                />

                <Button
                    onClick={() => addFolder()}
                    text='Ok'
                    variant={folderName ? 'primary' : 'gray'}
                    disabled={folderName ? false : true}
                    size='big'
                />
            </div>

            {errorMessage && <RedAlert>{errorMessage}</RedAlert>}
        </div>
    </Modal>
}

export default AddNewFolder